import { render, staticRenderFns } from "./ManagerDashboardBookingRequestsListItem.vue?vue&type=template&id=6d2a4c70"
import script from "./ManagerDashboardBookingRequestsListItem.vue?vue&type=script&lang=js"
export * from "./ManagerDashboardBookingRequestsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports